import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EducaButtonComponent } from '@educa/educa-ui';

import { IconComponent } from '@/shared/components/icons/icon.component';
import { EducaTextComponent } from '@/shared/components/text/text.component';

@Component({
  selector: 'app-forbidden',
  templateUrl: './forbidden.component.html',
  styleUrls: ['./forbidden.component.scss'],
  standalone: true,
  imports: [EducaTextComponent, EducaButtonComponent, IconComponent]
})
export class ForbiddenComponent {
  private router = inject(Router);

  /**
   * Navigates to help center section
   * @protected
   */
  protected goHomepage(): void {
    this.router.navigate(['/tickets']);
  }
}
